import React, {useEffect, useState} from 'react';
import {Accordion, Card} from "react-bootstrap";
import axios from "axios";
import {API} from "../../config";

const FAQ = () => {
    const [ faqs, setFaqs ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        try {
            const res = await axios.get(`${API}/v1/helps/faqs`, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }
            });
            if(res.data.success) {
                const data = res.data.faqs
                setFaqs(data)
            } 
        } catch (e) {
            console.log (e);
        }
        setLoading(false)
    };

    const onClickFaqLog = async (item) => {
        try {
            await axios.post(`${API}/v1/helps/faqs`, {
                ...item
            },{
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                }
            });
            console.log("Faq Log");
        } catch (e) {
            console.log (e);
        }
    }

    if (loading) {
        return (
            <div className="p-4 mt-4 text-center">
                <h2>Loading...</h2>
            </div>
        )
    }

    return (
        <div className="p-4 mt-4">
            <h2>Pertanyaan Sering Ditanya</h2>
            <Accordion className="mt-4">
                {
                    faqs.map((item,idx) => {
                        return (
                            <Card key={idx} className="p-4 pointer">
                                <Card className="p-0 border-0">
                                    <Accordion.Toggle 
                                        className="p-0 border-bottom-0" 
                                        as={Card.Header} 
                                        variant="link" 
                                        eventKey={idx}
                                        onClick={() => onClickFaqLog(item)}
                                    >
                                        <h6>{item.question_text}</h6>
                                    </Accordion.Toggle>
                                </Card>
                                <Accordion.Collapse eventKey={idx}>
                                    <Card.Body className={"p-0"}>
                                        {item.answer}
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        )
                    })
                }
            </Accordion>
            <div className="text-center mt-4">
                <h3>Tidak menemukan jawaban Anda?</h3>
                <div className="text-center mt-2">
                    <div className="nav-item">
                        <a
                        href="https://api.whatsapp.com/send?phone=+628111317800"
                        className={`nav-link`}>
                        <i className="fas fa-headset mr-3"></i>
                        <span><b>Klik disini untuk bantuan</b></span>
                        </a>
                    </div>
                </div>
            </div>
         
        </div>
    );
};


const data = [
    {
        question_text:"Apa yang sering terjadi?",
        question_code:"what_happened",
        answer:"tidak terjadi apa2",
        category:"basic",
        product:"shipping",
        channel:"dashboard"
    },
    {
        question_text:"Apa yang sering terjadi?",
        question_code:"what_happened",
        answer:"tidak terjadi apa2",
        category:"basic",
        product:"shipping",
        channel:"dashboard"
    },
    {
        question_text:"Apa yang sering terjadi?",
        question_code:"what_happened",
        answer:"tidak terjadi apa2",
        category:"basic",
        product:"shipping",
        channel:"dashboard"
    }
]
export default FAQ;
